import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
// import confetti from "canvas-confetti";

import bg from "./img/top_bg.webp";
import logo_l from "./img/logo_l.webp";
import syoei2 from "./img/syoei2.webp";
import { GeographFooter } from "./geograph/panels/geographFooter";
import SatelliteOrbit from "./SatelliteOrbit";
import jaxa_logo_black from "./img/jaxa_logo_black.png";
import jaxa_logo_pub from "./img/jaxa_logo_pub.png";

// ✅ Aboutの更新履歴データ（あなたの配置に合わせてパス調整）
import { ABOUT_RELEASES } from "./geograph/pages/about/releases";

const LS_KEY_LAST_SEEN_RELEASE = "geograph:lastSeenReleaseId";

/** prefers-reduced-motion を尊重（紙吹雪を抑制） */
function shouldReduceMotion() {
  try {
    return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
  } catch {
    return false;
  }
}

// /** よく見る“紙吹雪っぽい”発射（短時間） */
// function fireConfettiOnce() {
//   if (shouldReduceMotion()) return;

//   // 画面左右から2回、軽めに
//   const base = {
//     particleCount: 80,
//     spread: 70,
//     startVelocity: 35,
//     ticks: 200,
//     origin: { y: 0.7 },
//     zIndex: 9999,
//   };

//   confetti({ ...base, origin: { x: 0.2, y: 0.65 } });
//   confetti({ ...base, origin: { x: 0.8, y: 0.65 } });
// }

function UpdateModal({ release, onClose }) {
  // if (!release) return null;

  return (
    <div className="fixed inset-0 z-[200] pointer-events-auto">
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
        role="button"
        tabIndex={0}
        aria-label="close"
      />

      {/* modal */}
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-2xl rounded-2xl border border-white/10 bg-gradient-to-r from-black/90 via-black/80 to-black/90 shadow-2xl">
          <div className="p-5 md:p-7">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-xs text-gray-300">
                  {release.dateLabel}
                  {release.version ? ` / v${release.version}` : ""}
                </div>
                <div className="mt-1 text-lg md:text-2xl font-semibold text-white">
                  {release.title}
                </div>
              </div>

              <button
                onClick={onClose}
                className="shrink-0 rounded-md px-3 py-1 text-sm text-gray-200 hover:bg-white/10"
              >
                ×
              </button>
            </div>

            <div className="mt-4 space-y-3">
              {Array.isArray(release.bullets) &&
                release.bullets.map((b, i) => (
                  <div
                    key={`${release.id}_b_${i}`}
                    className="text-sm md:text-base text-gray-100 leading-relaxed"
                  >
                    ・{b}
                  </div>
                ))}
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-end gap-2">
              <Link
                to="/about"
                className="rounded-lg px-4 py-2 text-sm text-white bg-white/10 hover:bg-white/15 border border-white/10"
              >
                更新履歴を見る
              </Link>

              <button
                onClick={onClose}
                className="rounded-lg px-4 py-2 text-sm text-white bg-cyan-600/60 hover:bg-cyan-600/75 border border-cyan-200/20"
              >
                OK
              </button>
            </div>

            <div className="mt-3 text-[11px] text-gray-400">
              ※OKを押すと、この更新のお知らせは次回以降表示されません。
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const Home = () => {
  const latest = useMemo(() => ABOUT_RELEASES?.[0] || null, []);
  const latestId = String(latest?.id || "");

  const [showUpdate, setShowUpdate] = useState(false);
  const [modalRelease, setModalRelease] = useState(null);

  const isDev = process.env.NODE_ENV !== "production";

  const closeUpdate = () => {
    try {
      if (latestId) localStorage.setItem(LS_KEY_LAST_SEEN_RELEASE, latestId);
    } catch {
      //
    }
    setShowUpdate(false);
    setModalRelease(null);
  };

  // const runUpdateEffect = (release) => {
  //   setModalRelease(release || null);
  //   setShowUpdate(true);
  //   // 紙吹雪は“表示トリガの瞬間”に一回だけ
  //   fireConfettiOnce();
  // };

  // useEffect(() => {
  //   // latestが無ければ何もしない
  //   if (!latestId) return;

  //   let lastSeen = "";
  //   try {
  //     lastSeen = localStorage.getItem(LS_KEY_LAST_SEEN_RELEASE) || "";
  //   } catch {
  //     //
  //   }

  //   // 未読なら表示
  //   if (lastSeen !== latestId) {
  //     runUpdateEffect(latest);
  //   }
  // }, [latestId]);

  return (
    <>
      {/* ✅ 更新モーダル（未読のときだけ） */}
      {/* {showUpdate && (
        <UpdateModal release={modalRelease} onClose={closeUpdate} />
      )} */}

      <div
        className="absolute z-20 w-full h-screen bg-cover overflow-hidden"
        style={{ backgroundImage: `url(${bg})` }}
      ></div>

      <div className="flex flex-wrap md:flex-none py-[2vh] text-white text-xs md:text-base lg:text-xl xl:text-2xl">
        <div className="z-20 w-[46vw] ml-[2vw]">
          <Link
            to="/select"
            data-tip="サイトを使い始めます"
            className="w-1/4 lg:w-1/2"
          >
            <img src={logo_l} />
          </Link>
        </div>

        <div className="z-20 md:w-[21vw] ml-[4vw] flex items-center bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50 rounded-xl">
          <Link
            to="/select"
            className="w-full h-full flex items-center justify-center"
          >
            <div className="">
              ジオグラフを
              <br />
              はじめる
            </div>
          </Link>
        </div>

        <div className="z-20 md:w-[21vw] ml-[4vw] flex items-center bg-gradient-to-r from-black/50 via-black/70 to-black/90 hover:bg-gradient-to-br focus:ring-4 focus:ring-green-800/50 dark:focus:ring-green-800/50 rounded-xl">
          <Link
            to="/howto"
            className="w-full h-full flex items-center justify-center"
          >
            <div className="md:py-10 rounded-xl">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-[2em] w-[2em] mx-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              ジオグラフの使い方
            </div>
          </Link>
        </div>
      </div>

      <div>
        <div className="z-20">
          <SatelliteOrbit />
        </div>
        <div className="absolute bottom-10 ml-[4vw] w-2/12 z-20 mt-5">
          <a href="https://www.satnavi.jaxa.jp/ja/" target="_blank" rel="noreferrer">
            <img
              src={jaxa_logo_pub}
              className="w-3/4 rounded-xl  bg-gradient-to-r from-white/50 via-white/70 to-white/90 hover:bg-gradient-to-br pr-2"
            />
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 right-3 z-20 pointer-events-auto">
        {/* 宇宙っぽい“ガラスパネル” */}
        <div className="rounded-2xl border border-white/10 bg-gradient-to-b from-black/35 via-black/25 to-black/35 backdrop-blur-md shadow-[0_10px_30px_rgba(0,0,0,0.55)] p-2">
          <div className="flex flex-col gap-2">
            {/* 共通ボタンスタイル：ガラス＋淡い発光 */}
            {/* <a
              href="http://gg-v3.kashika.net/map/8/11-01/福岡県糸島市?____11-03"
              target="_blank"
              rel="noreferrer"
              className="group flex items-center gap-2 rounded-xl px-3 py-2 text-xs md:text-sm text-white/90 border border-white/10 bg-gradient-to-r from-cyan-500/10 via-sky-500/10 to-blue-500/10 hover:from-cyan-500/20 hover:via-sky-500/20 hover:to-blue-500/20 hover:border-white/20 hover:text-white transition"
              title="テストページを開く"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 opacity-80 group-hover:opacity-100"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
              <span className="font-medium">テスト</span>
              <span className="ml-auto text-[10px] text-white/50 group-hover:text-white/70">
                ↗
              </span>
            </a> */}

            <button
              onClick={() => {
                try {
                  localStorage.clear();
                } catch {
                  //
                }
                // ✅ 初期化が“効いた”ことが分かるように、ページ全体を再読み込み
                window.location.reload();
              }}
              className="group flex items-center gap-2 rounded-xl px-3 py-2 text-xs md:text-sm text-white/90 border border-white/10 bg-gradient-to-r from-white/5 via-white/5 to-white/5 hover:bg-white/10 hover:border-white/20 hover:text-white transition"
              title="ローカルストレージを初期化"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 opacity-80 group-hover:opacity-100"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 4v6h6M20 20v-6h-6"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M20 10a8 8 0 10-2.34 5.66"
                />
              </svg>
              <span className="font-medium">初期化</span>
            </button>

            {/* ✅ devだけ：強制エフェクト（localStorageは触らない） */}
            {/* {isDev && (
              <button
                onClick={() => runUpdateEffect(latest)}
                className="group flex items-center gap-2 rounded-xl px-3 py-2 text-xs md:text-sm text-white/90 border border-white/10 bg-gradient-to-r from-fuchsia-500/10 via-purple-500/10 to-indigo-500/10 hover:from-fuchsia-500/20 hover:via-purple-500/20 hover:to-indigo-500/20 hover:border-white/20 hover:text-white transition"
                title="デバッグ：更新エフェクトを実行"
              >
                <span className="text-base leading-none">🎉</span>
                <span className="font-medium">エフェクト</span>
                <span className="ml-auto text-[10px] text-white/50 group-hover:text-white/70">
                  dev
                </span>
              </button>
            )} */}

            <Link
              to="/about"
              className="group flex items-center gap-2 rounded-xl px-3 py-2 text-xs md:text-sm text-white/90 border border-white/10 bg-gradient-to-r from-cyan-500/10 via-teal-500/10 to-emerald-500/10 hover:from-cyan-500/20 hover:via-teal-500/20 hover:to-emerald-500/20 hover:border-white/20 hover:text-white transition"
              title="更新履歴を見る"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 opacity-80 group-hover:opacity-100"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                />
              </svg>
              <span className="font-medium">更新履歴</span>
              <span className="ml-auto text-[10px] text-white/50 group-hover:text-white/70">
                →
              </span>
            </Link>
          </div>
        </div>
      </div>

      <GeographFooter />
    </>
  );
};
